import { useEffect, useState } from "react";
import "../Home/Home.css";
import Header from "@shared/components/Atoms/Contents/Header";
import FooterMain from "@shared/components/Atoms/Contents/FooterMain";
import { FOOTER } from "@shared/util/brand";
import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL || `${window.location.origin}/api`;

function Support() {
  const supportEmail = FOOTER.email || "agent@videobrief.ai";
  const [faqs, setFaqs] = useState([]);
  const [loadingFaqs, setLoadingFaqs] = useState(true);

  useEffect(() => {
    axios
      .get(`${API_URL}/basic/support-faq`)
      .then((res) => setFaqs(res.data?.data || []))
      .catch(() => setFaqs([]))
      .finally(() => setLoadingFaqs(false));
  }, []);

  return (
    <div>
      <Header />

      <div id="help-page">
        <div className="container mx-auto px-4 py-8">
          <div className="page-header flex justify-between items-center mb-6 mt-[60px]" />

          <div className="max-w-4xl mx-auto my-10 p-8 rounded-xl">
            <h1 className="text-4xl font-bold text-gray-900 mb-6">
              Support Center
            </h1>
            <p className="text-gray-700 mb-6">
              We&apos;re here to help! Find answers to common questions or use the
              chat widget in the bottom-left corner to reach us.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">
              Contact Information
            </h2>
            <div className="bg-gray-100 p-4 rounded-lg mb-6">
              <div className="mb-2 flex">
                <strong className="w-24">Email:</strong>
                <span>{supportEmail}</span>
              </div>
              <div className="flex">
                <strong className="w-24">Hours:</strong>
                <span>Monday - Friday, 9 AM - 6 PM PST</span>
              </div>
            </div>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">
              Privacy, cookies & accessibility
            </h2>
            <div className="bg-gray-100 p-6 rounded-lg mb-6 space-y-3 text-gray-700">
              <p>
                <a href="/cookie-policy" className="text-blue-700 underline">Cookie Policy</a>
                {" · "}
                <a href="/accessibility" className="text-blue-700 underline">Accessibility Statement</a>
                {" · "}
                <a href="/do-not-sell-or-share" className="text-blue-700 underline">Do Not Sell or Share</a>
              </p>
              <p className="text-sm">
                Live chat requires functional cookies — enable them via the cookie banner or footer
                Cookie settings link.
              </p>
            </div>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">
              How to Get Help
            </h2>
            <div className="bg-gray-100 p-6 rounded-lg mb-6 space-y-4">
              <div>
                <h3 className="text-lg font-semibold text-gray-800">
                  💬 Live Chat
                </h3>
                <p className="text-gray-700">
                  Click the chat bubble in the bottom-left corner. Our assistant
                  answers common questions; a human follows up when needed.
                </p>
              </div>
              <div>
                <h3 className="text-lg font-semibold text-gray-800">
                  📧 Email Support
                </h3>
                <p className="text-gray-700">
                  Send us an email at {supportEmail}. We typically respond
                  within 24 hours during business days.
                </p>
              </div>
            </div>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">
              Frequently Asked Questions
            </h2>
            {loadingFaqs && (
              <p className="text-gray-500 text-sm">Loading FAQs…</p>
            )}
            {!loadingFaqs && faqs.length === 0 && (
              <p className="text-gray-500 text-sm">FAQs will appear here shortly.</p>
            )}
            <div className="space-y-6">
              {faqs.map((item) => (
                <div key={item.question}>
                  <h3 className="text-lg font-semibold text-gray-800">
                    {item.question}
                  </h3>
                  <p className="text-gray-700">{item.answer}</p>
                </div>
              ))}
            </div>

            <h2 className="text-2xl font-semibold text-gray-800 mt-10 mb-2">
              Feedback & Feature Requests
            </h2>
            <p className="text-gray-700">
              We love hearing from our users! Send feature requests and feedback
              to{" "}
              <a
                href={`mailto:${supportEmail}`}
                className="text-gray-800 underline"
              >
                {supportEmail}
              </a>
              , or use live chat while signed in to attach a screenshot with a
              bug label.
            </p>
          </div>
        </div>
      </div>
      <FooterMain />
    </div>
  );
}

export default Support;
